import classnames from 'classnames'
import { CSSProperties, forwardRef } from 'react'

import useDeviceInfo from '@src/quince-site-common/src/hooks/useDeviceInfo'
import getMaxWidthInPx from '@src/quince-site-common/src/utils/getMaxWidthInPx'

import { RichText, RichTextProps } from '../../molecules'
import { Image, ImageProps } from '../image'
import FillRangeItem, { FillRangeItemProps } from '../reviews/fillRangeItem'

import styles from './featureSectionFour.module.scss'

export interface FeatureSectionFourProps {
  sectionImage: ImageProps
  iconProps?: ImageProps | undefined
  heading?: RichTextProps | undefined
  description?: RichTextProps | undefined
  fillRange?: FillRangeItemProps
  className?: string
  style?: CSSProperties
  progressBarClassName?: string
  fillBarClassName?: string
  fillBarStyle?: CSSProperties
  subSectionClassName?: string
  subSectionStyle?: CSSProperties
}

export const FeatureSectionFour = forwardRef<HTMLDivElement, FeatureSectionFourProps>(function FeatureSectionFourEl(
  { className = '', ...props }: FeatureSectionFourProps,
  ref,
) {
  const wrapClassnames = classnames(styles.featureSectionFourWrap, className)
  const deviceInfo = useDeviceInfo()

  return (
    <div
      className={wrapClassnames}
      style={{
        ...props.subSectionStyle,
      }}
      ref={ref}
    >
      <div className={classnames(styles.left, props.subSectionClassName)}>
        <div className={classnames(styles.contentWrap)}>
          <div className={styles.infoBox}>
            {props.iconProps && (
              <div className={styles.left__iconWrapper}>
                <Image
                  alt={props.iconProps.alt}
                  {...props.iconProps}
                  className={classnames(styles.left__icon, props.iconProps.className)}
                />
              </div>
            )}
            {/* {props.heading !== '' && <h4 className={styles.heading}>{props.heading}</h4>} */}
            {props.heading && <RichText {...props.heading} className={styles.heading} />}
            {props.description && <RichText {...props.description} className={styles.featureDescription} />}
          </div>
          {props.fillRange && (
            <FillRangeItem
              {...props.fillRange}
              border
              rounded
              className={styles.scallRangeWrap}
              progressBarClassName={classnames(styles.scallRangeWrap__progressBar, props.progressBarClassName)}
              fillBarClassName={classnames(props.fillBarClassName)}
              fillBarStyle={props.fillBarStyle}
            />
          )}
        </div>
      </div>
      <div className={styles.right}>
        <Image
          alt={props.sectionImage.alt}
          {...props.sectionImage}
          useNative
          forceReduceQuality
          maxWidth={getMaxWidthInPx({
            maxWidthDesktopInRem: styles.imageWidthDesktop,
            maxWidthMobileInRem: styles.imageWidthMobile,
            deviceType: deviceInfo.deviceType,
          })}
        />
      </div>
    </div>
  )
})

export default FeatureSectionFour
